import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';

import {useReportDialogStore} from '../../../store/reportStore/reportDialogStore';

import ReportConfirmModal from './ReportConfirmModal';
import ReportInputModal from './ReportInputModal';

import '../../../styles/_reportComponents.scss';

const ReportDialogHost: React.FC = () => {
  const dialog = useReportDialogStore((s) => s.dialog);
  const close = useReportDialogStore((s) => s.close);

  useEffect(() => {
    if (!dialog || dialog.type !== 'confirm') return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prev;
    };
  }, [dialog]);

  if (!dialog) return null;

  const tree =
    dialog.type === 'confirm' ? (
      <ReportConfirmModal options={dialog.options} onClose={close} />
    ) : (
      <ReportInputModal options={dialog.options} onClose={close} />
    );

  return createPortal(tree, document.body);
};

export default ReportDialogHost;
